module.exports = __webpack_public_path__ + "img/game2.60ab145c.jpg";